import React from 'react';

import type {NotificationService} from '../services/Notification.service';

import {NotificationContext} from './notification.context';

export const NotificationProvider: React.FC<
    React.PropsWithChildren<{notifications: NotificationService}>
> = ({children, notifications}) => {
    return (
        <NotificationContext.Provider value={notifications}>
            {children}
        </NotificationContext.Provider>
    );
};
